export const translations= {
  es: {
    myReservations: "Mis Reservaciones",
    filterByService: "Filtrar por servicio",
    servicePlaceholder: "Nombre del servicio...",
    sortBy: "Ordenar por",
    date: "Fecha",
    serviceName: "Nombre de servicio",
    ascending: "Orden ascendente",
    descending: "Orden descendente",
    loadingReservations: "Cargando reservaciones...",
    error: "Error",
    retry: "Reintentar",
    noReservations: "No hay reservaciones que coincidan con los criterios de búsqueda.",
    serviceNotAvailable: "Servicio no disponible",
    client: "Cliente",
    contact: "Contacto",
    total: "Total",
    participants: "participantes",
    noCredentials: "No se encontraron credenciales de autenticación",
    phoneErrorPrefix: "Debe usar el prefijo +506 o escribir 8 dígitos sin prefijo.",
    phoneErrorInvalid: "Número de Costa Rica inválido. Formatos válidos: 88887777 o +50688887777.",
    client_email: "Correo"
  },
  en: {
    myReservations: "My Reservations",
    filterByService: "Filter by service",
    servicePlaceholder: "Service name...",
    sortBy: "Sort by",
    date: "Date",
    serviceName: "Service name",
    ascending: "Ascending order",
    descending: "Descending order",
    loadingReservations: "Loading reservations...",
    error: "Error",
    retry: "Retry",
    noReservations: "No reservations match the search criteria.",
    serviceNotAvailable: "Service not available",
    client: "Client",
    contact: "Contact",
    total: "Total",
    participants: "participants",
    noCredentials: "No authentication credentials found",
    phoneErrorPrefix: "Use +506 prefix or write 8 digits without prefix.",
    phoneErrorInvalid: "Invalid Costa Rican number. Valid formats: 88887777 or +50688887777.",
    client_email: "Email"

  }
};